<ng-container *transloco="let t; scope: 'app-update'; prefix: 'app-update'">
  <de-modal
    variant="info"
    size="sm"
    iconClass="bi-arrow-clockwise"
    [open]="isUpdateAvailable()"
    [dismissible]="false"
    [closeOnBackdropClick]="false"
    [colorHeader]="false"
    [title]="t('title')"
  >
    <div deModalBody class="app-update-notification">
      <p>{{ t('description') }}</p>

      <div class="app-update-notification__actions">
        <de-button
          type="button"
          variant="primary"
          color="primary"
          [disabled]="isUpdating()"
          (buttonClick)="onUpdate()"
        >
          {{ t('updateNow') }}
        </de-button>
      </div>
    </div>
  </de-modal>
</ng-container>
